/**
 * Upload-new.tsx
 * New-page entry point for Upload redesign.
 * This wrapper reuses the existing UploadPage logic until Figma-specific UI is applied.
 */

import React from 'react';
import UploadPage from './Upload';

/**
 * UploadNew
 * Named page component for the new Upload route.
 */
function UploadNew(): React.ReactElement
{
    return <UploadPage />;
}

export default UploadNew;
